import { render } from "./Step.vue?vue&type=template&id=61c414f6"
import script from "./Step.vue?vue&type=script&lang=js"
export * from "./Step.vue?vue&type=script&lang=js"

import "./Step.vue?vue&type=style&index=0&id=61c414f6&lang=scss"
script.render = render

export default script